import { render, staticRenderFns } from "./SpecificVe.vue?vue&type=template&id=23e668d7&"
import script from "./SpecificVe.vue?vue&type=script&lang=js&"
export * from "./SpecificVe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports